<template>
  <div class="psPatientBtnNewDisease">
    <el-button circle style="border: 2px solid black; margin: 4px 0; color: black; font-weight: bold;" size="mini" @click="newDisease">
      <i class="el-icon-plus" style="font-weight: 900"></i>
    </el-button>
    <span class="tooltip">Nueva enfermedad de base</span>    
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'PsPatientBtnNewDisease',
  computed: {
    ...mapState('patients', ['patient'])
  },
  methods: {
    ...mapMutations('patients', ['PATIENTS_DIALOG_DISEASES', 'PATIENTS_LOADING', 'PATIENTS_DISEASES_LIST_SELECTED']),
    ...mapActions('diseases', ['getDiseasesHTTP']),
    async newDisease () {
      this.PATIENTS_LOADING(true)
      this.PATIENTS_DIALOG_DISEASES(true)
      await this.getDiseasesHTTP()
      this.PATIENTS_DISEASES_LIST_SELECTED(this.patient.diseases.map( item => item.diseaseDescription))
      this.PATIENTS_LOADING(false)
    }
  }
}
</script>

<style scoped>
  .psPatientBtnNewDisease { position: relative; margin-left: 15px;}
  .tooltip { 
    visibility: hidden;
    width: 180px;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    text-align: center;
    padding: 4px 0;
    border-radius: 12px;
    position: absolute;
    z-index: 10;
    font-size: 0.8rem;
    left: 5px;
    top: -30px
  }

  .psPatientBtnNewDisease:hover .tooltip {
    visibility: visible;
  }

/* Medium devices (tablets, less than 992px) */
  @media (max-width: 991.98px) {
    .tooltip { display: none;}    
  }
</style>